import React from 'react';
import { ButtonWrapper, Container, Title, UploadContainer } from './Style';
import { SingleFileUpload, CommonButton } from '@Components';
import { UPLOAD_DOCUMENT_SCREEN } from '../../../utils/constants';
import { DocumentUploadComponentProps } from '../../../utils/interface';

const DocumentUploadComponent = (props: DocumentUploadComponentProps): React.ReactElement => {
  const {
    data,
    files,
    setFiles,
    fileErrorFlag,
    handleDocumentUpload,
    isNiumForexUserFileSizeError
  } = props;

  return (
    <Container>
      <Title>{data?.label}</Title>
      <UploadContainer>
        <SingleFileUpload
          files={files}
          setFiles={setFiles}
          heading={UPLOAD_DOCUMENT_SCREEN.documentUpload.heading}
          replaceText={UPLOAD_DOCUMENT_SCREEN.documentUpload.replace}
          error={fileErrorFlag}
          isNiumForexUserFileSizeError={isNiumForexUserFileSizeError}
        />
      </UploadContainer>
      <ButtonWrapper>
        <CommonButton
          text={UPLOAD_DOCUMENT_SCREEN.documentUpload.submit}
          width={450}
          height={46}
          onClick={() => handleDocumentUpload(data?.document_code, data?.document_input_type)}
        />
      </ButtonWrapper>
    </Container>
  );
};

export default DocumentUploadComponent;
